"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugVars = void 0;
exports.logInfoIf = logInfoIf;
exports.debugVars = [];
function logInfoIf(logger, condition, msg) {
    if (condition) {
        logger.info(msg);
    }
}
//# sourceMappingURL=debugHelpers.js.map